<template>
    <li class="list-group-item px-3">
        <div class="d-flex"
             v-if="task.type === 'PLAIN'">
            <div class="flex-grow-1 mr-2"
                 v-bind:class="{ 'text-decoration-line-through': isDone }">
                {{ task.name }}
            </div>
            <div class="d-flex align-items-center">
                <input class="checkbox-lg"
                       type="checkbox"
                       v-model="isDone">
            </div>
        </div>
        <div v-else-if="task.type === 'VOTE'">
            <div class="d-flex">
                {{ task.name }}
            </div>
            <div class="mt-2">
                <div class="d-flex align-items-center mb-2"
                     v-for="({ _id, label, type, }, index) in task.fields"
                     v-bind:key="_id">
                    <b-form-input class="field-input flex-grow-1 mr-1"
                                  trim
                                  size="sm"
                                  v-bind:type="type"
                                  v-bind:placeholder="label"
                                  v-model="fieldValues[index]">
                    </b-form-input>
                    <button class="btn btn-sm btn-light border"
                            v-on:click="save">
                        <font-awesome-icon icon="save"></font-awesome-icon>
                    </button>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    import {
        BFormInput,
    } from "bootstrap-vue";

    export default {
        name: "TaskletItem",
        components: {
            BFormInput,
        },
        props: {
            "task": {
                type: Object,
                required: true,
            },
        },
        data () {
            return {
                isDoneCopy: null,

                fieldValues: [],
            };
        },
        computed: {
            "isDone": {
                get () {
                    if (this.task) {
                        return this.task.isDone;
                    }
                    return false;
                },
                set (val) {
                    this.$emit(
                        "change",
                        Object.assign(
                            {},
                            this.task,
                            { "isDone": val }
                        )
                    );
                },
            },
        },
        methods: {
            save () {
                const fields = this.task.fields
                    .slice(0);

                fields.forEach(
                    (field, ind) => field.value = this.fieldValues[ind]
                );

                this.$emit(
                    "change",
                    Object.assign(
                        {},
                        this.task,
                        { fields }
                    )
                );
            },
        },
        mounted () {
            if (this.task) {
                this.fieldValues = this.task.fields
                    .map(
                        ({ value }) => value
                    );
            }

        },
        watch: {
            "task" (newVal) {
                this.fieldValues = newVal.fields
                    .map(
                        ({ value }) => value
                    );
            },
        },
    }
</script>

<style lang="scss" scoped>
    .checkbox-lg {
        height: 20px;
        width: 20px;
    }

    .text-decoration-line-through {
        text-decoration: line-through;
    }

    .field-input {
        width: 200px;
    }
</style>
